import {StyleSheet} from 'react-native';

import theme from '../../style/theme';

const styles = StyleSheet.create({
  textDefault: {
    color: 'white',
  },
  // Search Bar
  searchBarHolder: {
    width: '100%',
    paddingTop: 10,
    minHeight: 50,
    backgroundColor: 'white',
    alignItems: 'center',
  },
  searchBar: {
    width: '100%',
    marginBottom: 12,
    flexDirection: 'row',
  },
  searchBarPre: {
    alignSelf: 'center',
    marginRight: 8,
    color: 'lightgrey',
  },
  searchBarPost: {
    alignSelf: 'center',
    marginLeft: 8,
  },
  searchIcon: {
    color: 'lightgrey',
  },
  textInput: {
    flex: 1,
  },
  primaryListWrapper: {
    marginTop: 4,
    marginBottom: 0,
  },
  primaryListContent: {
    paddingBottom: 80,
  },
  secondaryListWrapper: {
    marginVertical: 4,
    flex: 1,
  },
  section: {
    marginTop: 12,
  },
  sectionHeader: {
    fontSize: 16,
    fontWeight: '300',
    color: theme.colour.text.heading.primary,
    marginBottom: 4,
    backgroundColor: 'white',
  },
  columnWrapperStyle: {gap: 8},
});

export default styles;
